<div class="team-grid">
    <div *ngIf="image" class="teamgrid-user">
        <img [src]="image" alt="" class="img-fluid" loading="lazy">
    </div>
    <div class="teamgrid-content">
        <h4 *ngIf="title">{{title}}</h4>
        <span *ngIf="content">{{content}}</span>
    </div>
</div>